import React, { Component } from 'react';

import { Loading, SERVER_ERROR } from 'commons';
import request from '../request';

class MFA extends Component {
  state = {
    loading: false,
    error: '',
    mfa: '',
    mfaStatus: 0 // 0=undefined, 1=ok, -1=error
  };

  handleChange = e => {
    this.setState({ mfa: e.target.value });
  };

  handleSubmit = async e => {
    e.preventDefault();

    const { email, requestId, action } = this.props;
    const { mfa } = this.state;

    this.setState({ loading: true });

    const formData = [
      `action=${action}`,
      `code=${encodeURIComponent(mfa)}`,
      `email=${encodeURIComponent(email)}`,
      `requestId=${encodeURIComponent(requestId)}`
    ];

    try {
      const res = await request('/session/login', formData.join('&'));

      if (res.status >= 300 || res.status < 200) {
        this.setState({ loading: false, ...SERVER_ERROR });
        return;
      }

      this.setState({ mfaStatus: 1 });
      const data = await res.json();

      if (data.error === 401) {
        this.setState({ mfaStatus: -1, loading: false });
      } else {
        this.props.onUpdateSession({ action: 'request' });
      }

      if (data.action === 'success') {
        document.location.href = data.redirectUri;
      } else {
        this.props.onUpdateSession({
          action: data.action,
          requestId: data.requestId,
          email: data.email
        });
      }
    } catch (error) {
      this.setState({ loading: false, ...SERVER_ERROR });
    }
  };

  render() {
    const { mfa, mfaStatus, loading, error } = this.state;

    if (loading) return <Loading />;
    if (error.length > 0) return <div className="boxed-container"><div className="margin-top-large">{error}</div></div>;

    const mfaErrorMessage =
      mfaStatus === -1 ? <div className="message-error">The credentials you supplied were incorrect</div> : null;

    return (
      <div className="boxed-container">
        <p className="invite">Type your MFA code</p>
        {mfaErrorMessage}
        <form className="form-fixed-width-small form-animated" onSubmit={this.handleSubmit}>
          <div className="margin-bottom-large">
            <input
              placeholder="MFA Code"
              type="text"
              autoFocus
              autoComplete="no"
              value={mfa}
              onChange={this.handleChange}
            />
          </div>
          <input className="btn" type="submit" value="NEXT" />
        </form>
      </div>
    );
  }
}

export default MFA;
